import { StateService } from "@uirouter/angularjs";
import { IReportGroup } from "../../../../../../../../reporting/interfaces/IReportGroup";
import { Machine } from "../../../../../../models/machine";
import {
  MachineConfiguration,
  MachineConfigurationView,
} from "../../../../../../models/machineConfiguration";
import {
  ConversionModalService,
  vsServiceName as ConversionModalServiceName,
} from "../../../../../conversionModal";
import { IOnInit } from "angular";
import { AuthorizedUiElementService } from "../../../../../../../../ui/authorizedUiElement";
import { SingleMachineChangeChildStateConfig } from "../../../../../machineChange";

export interface MachineDetailConfigurationViewArgs {
  machineConfiguration: MachineConfiguration;
  changeIsPending: boolean;
  dateString: string;
  currentConfiguration: boolean;
}

export class MachineDetailConfigurationViewController implements IOnInit {
  static $inject = [
    "dateFilter",
    "$state",
    ConversionModalServiceName,
    "environment",
  ];

  configurations!: MachineConfiguration[];
  readonly machine!: Machine<MachineConfiguration>;
  readonly reportGroup!: IReportGroup;
  accordionHeading!: (args: MachineDetailConfigurationViewArgs) => string;

  constructor(
    private readonly dateFilter: (d: any) => string | undefined,
    private readonly $state: StateService,
    private readonly conversionModalService: ConversionModalService,
    private readonly environment: { Date: Date }
  ) {}

  $onInit(): void {
    this.accordionHeading ??= (args) => this.getHeadingDefault(args);
    this.configurations = [...(this.machine.Configs ?? [])];
    this.configurations.sort(
      (first, second) => (second.Order ?? 0) - (first.Order ?? 0)
    );
  }

  childClicked(
    child: SingleMachineChangeChildStateConfig,
    childService: AuthorizedUiElementService<SingleMachineChangeChildStateConfig>
  ) {
    switch (child.id) {
      case "clone":
        const machineId = this.machine.Id;
        childService.navigateToChild(child, {
          modelMachineId: machineId,
        });
        break;
      case "conversion":
        const modalInstance = this.conversionModalService.openModal();
        modalInstance.result.then((result) => {
          return childService.navigateToChild(child, {
            machineId: this.machine.Id,
            modelMachineId: result.machineId,
            modelMachineConfigurationId: result.machineConfigurationId,
          });
        });
        break;
      default:
        const sref = childService.getSref(child);
        this.$state.go(sref);
    }
  }

  changeIsPending(machineConfiguration: MachineConfiguration): boolean {
    return machineConfiguration.Date! > this.environment.Date;
  }

  getHeading(machineConfiguration: MachineConfiguration) {
    return this.accordionHeading({
      machineConfiguration,
      changeIsPending: this.changeIsPending(machineConfiguration),
      dateString: this.dateFilter(machineConfiguration.Date) ?? "",
      currentConfiguration: machineConfiguration.CurrentConfiguration ?? false,
    });
  }

  private getHeadingDefault(args: MachineDetailConfigurationViewArgs) {
    const {
      machineConfiguration,
      changeIsPending,
      dateString,
      currentConfiguration,
    } = args;

    return `${machineConfiguration.ChangeType} - ${dateString}${
      currentConfiguration && !changeIsPending ? " - Current" : ""
    }${changeIsPending ? " - Pending" : ""}`;
  }
}
